/*
 * The register of drivers, as GET /drivers returns it (stanic-api
 * DataStructures/Driver.go), and who drives which vehicle.
 *
 * Every field but the name is optional: a driver the office knows by name and nothing
 * else is a driver. All of them are personal data about an employee, so nothing here is
 * ever written to a log or put into an address.
 */

export interface IDriver {
    id:          string
    name:        string
    phone:       string
    email:       string
    employee_no: string
    /*
     * The identifier of an iButton, an RFID card or a Bluetooth fob. NOTHING READS IT
     * YET — it is stored for a later phase in which the tracker says who is driving,
     * and the form says as much where somebody types it.
     */
    tag_id:      string
    note:        string
    active:      boolean
}

/** What the dialog holds while somebody is filling it in. */
export type IDriverRequest = Omit<IDriver, 'id'>

/*
 * One stretch of time during which a vehicle was somebody's, as
 * GET /devices/{imei}/drivers returns it, newest first. `to` is a zero time for the
 * assignment that is current. `driver_name` is the name AS IT IS NOW — the opposite of
 * what a logbook entry does, because this list answers "who has this car".
 */
export interface IVehicleDriver {
    id:          string
    imei:        string
    driver_id:   string
    driver_name: string
    from:        string
    to:          string
}

/** What PUT /devices/{imei}/driver answers with: who drives it now, or nobody. */
export interface ICurrentDriver {
    imei:        string
    driver_id:   string
    driver_name: string
}

/** What that route asks for. `from` is left out entirely when it means "now". */
export interface IVehicleDriverRequest {
    driver_id: string
    from?:     string
}

/** Which drivers a listing asks for — the API's own `?active=` values. */
export const DriverFilter = {
    Active:   'true',
    Inactive: 'false',
    All:      'all',
} as const

/** Where a drive's driver came from, as a Trip reports it. */
export const DriverSource = {
    Entry:      'entry',
    Assignment: 'assignment',
} as const
